import moment from 'moment'

export function getWeekdaysLong(): string[] {
  return [
    i18n.t(`datepicker_sunday`, `Sonntag`),
    i18n.t(`datepicker_monday`, `Montag`),
    i18n.t(`datepicker_tuesday`, `Dienstag`),
    i18n.t(`datepicker_wednesday`, `Mittwoch`),
    i18n.t(`datepicker_thursday`, `Donnerstag`),
    i18n.t(`datepicker_friday`, `Freitag`),
    i18n.t(`datepicker_saturday`, `Samstag`),
  ]
}

export function getWeekdaysShort(): string[] {
  return [
    i18n.t(`datepicker_short_sunday`, `So`),
    i18n.t(`datepicker_short_monday`, `Mo`),
    i18n.t(`datepicker_short_tuesday`, `Di`),
    i18n.t(`datepicker_short_wednesday`, `Mi`),
    i18n.t(`datepicker_short_thursday`, `Do`),
    i18n.t(`datepicker_short_friday`, `Fr`),
    i18n.t(`datepicker_short_saturday`, `Sa`),
  ]
}

export function getMonthsLong(): string[] {
  return [
    i18n.t(`datepicker_january`, `Januar`),
    i18n.t(`datepicker_february`, `Februar`),
    i18n.t(`datepicker_march`, `März`),
    i18n.t(`datepicker_april`, `April`),
    i18n.t(`datepicker_may`, `Mai`),
    i18n.t(`datepicker_june`, `Juni`),
    i18n.t(`datepicker_july`, `Juli`),
    i18n.t(`datepicker_august`, `August`),
    i18n.t(`datepicker_september`, `September`),
    i18n.t(`datepicker_october`, `Oktober`),
    i18n.t(`datepicker_november`, `November`),
    i18n.t(`datepicker_december`, `Dezember`),
  ]
}

type TMonthYearOption = { label: string; value: string }

export function getMonthYearOptions(): TMonthYearOption[] {
  const currentYear = moment().year()
  const options: TMonthYearOption[] = []
  for (let i = currentYear - 5; i < currentYear + 5; i++) {
    getMonthsLong().forEach((month, index) => {
      const year = String(i)
      const date = moment.unix(0)
      date.month(index)
      date.year(year as any as number)
      options.push({
        label: `${month} ${year}`,
        value: date.toISOString(),
      })
    })
  }
  return options
}
